import { extends as _extends, typeof as _typeof } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Spacer, FormField, Flex, Label, TextButton, FormHelp, AdornedInput, Adornment, Input } from '@zillow/constellation';
import InputMask from 'inputmask';
import React, { useRef, useEffect, useCallback } from 'react';
import { useFormContext, useFormState } from 'react-hook-form';
import { sendTextButtonInteractionEvent } from '../../utils/clickstream/MortgageCalculatorClickstream.js';
import FieldTooltip from './FieldTooltip.js';

function TextField(_ref) {
  var _proxyFormState$error;
  var label = _ref.label,
    leftAdornment = _ref.leftAdornment,
    rightAdornment = _ref.rightAdornment,
    name = _ref.name,
    config = _ref.config,
    description = _ref.description,
    textButtonName = _ref.textButtonName,
    _onChange = _ref.onChange,
    _onBlur = _ref.onBlur,
    autoComplete = _ref.autoComplete,
    format = _ref.format,
    type = _ref.type,
    required = _ref.required,
    textInputRef = _ref.textInputRef,
    textButtonInteractionEventInfo = _ref.textButtonInteractionEventInfo,
    tooltip = _ref.tooltip,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    textButtonHref = _ref.textButtonHref,
    mask = _ref.mask;
  var form = useFormContext();
  var proxyFormState = useFormState();
  var error = proxyFormState === null || proxyFormState === void 0 || (_proxyFormState$error = proxyFormState.errors[name]) === null || _proxyFormState$error === void 0 ? void 0 : _proxyFormState$error.message;
  var field = form.register(name, config);
  var inputRef = useRef(null);

  // Format on mount
  useEffect(function () {
    if (format) {
      var defaultValue = form.getValues(name);
      if (defaultValue) {
        inputRef.current.value = format(defaultValue);
      }
    }
  }, []);
  return /*#__PURE__*/React.createElement(Spacer, {
    marginBottom: "xs"
  }, /*#__PURE__*/React.createElement(FormField, {
    disabled: disabled,
    label: /*#__PURE__*/React.createElement(Flex, {
      display: "flex",
      alignItems: "center",
      marginBottom: "xxs"
    }, /*#__PURE__*/React.createElement(Label, null, label), tooltip && /*#__PURE__*/React.createElement(FieldTooltip, tooltip), textButtonName ? /*#__PURE__*/React.createElement(Flex, {
      display: "flex",
      justifyContent: "space-between",
      marginLeft: "auto"
    }, /*#__PURE__*/React.createElement(TextButton, {
      as: "a",
      target: "_blank",
      rel: "nofollow",
      href: textButtonHref,
      onClick: function onClick() {
        return textButtonInteractionEventInfo ? sendTextButtonInteractionEvent(textButtonInteractionEventInfo) : '';
      }
    }, textButtonName)) : ''),
    required: required,
    description: /*#__PURE__*/React.createElement(FormHelp, {
      error: Boolean(error)
    }, error || description || /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0")),
    control: /*#__PURE__*/React.createElement(AdornedInput, {
      error: Boolean(error),
      leftAdornment: leftAdornment && /*#__PURE__*/React.createElement(Adornment, null, leftAdornment),
      rightAdornment: rightAdornment && /*#__PURE__*/React.createElement(Adornment, null, rightAdornment),
      input: /*#__PURE__*/React.createElement(Input, _extends({}, field, {
        type: type || 'text',
        placeholder: placeholder,
        onBlur: function onBlur(e) {
          field.onBlur(e);
          _onBlur === null || _onBlur === void 0 || _onBlur(e);
        },
        onChange: function onChange(e) {
          field.onChange(e);
          _onChange === null || _onChange === void 0 || _onChange(e);
        },
        onInput: format ? function (e) {
          e.target.value = format(e.target.value);
        } : undefined
        // The "mask" properties will not update, as this is memoized.
        ,
        ref: useCallback(function (el) {
          if (typeof textInputRef === 'function') {
            textInputRef(el);
          } else if (_typeof(textInputRef) === 'object' && textInputRef) {
            textInputRef.current = el;
          }
          if (el && mask) {
            var masker = new InputMask(mask);
            masker.mask(el);
          }
          inputRef.current = el;
          field.ref(el);
        }, []),
        autoComplete: autoComplete
      }))
    })
  }));
}

export { TextField as default };
